module.exports = __webpack_public_path__ + "img/markerMetroOrange.702660ba.svg";